export default "__VITE_ASSET__BbJ0z6SB__"